import React from "react";
import {
  Button,
  Row,
  Col,
  CardBody,
  Collapse,
  Card,
  Input,
  Label,
  Table
} from "reactstrap";

//Images
import ic_arrow_down from "ASSETS/Images/ic_arrow_down.svg";
import ic_add from "ASSETS/Images/ic_add_storage.svg";
import ic_delete from "ASSETS/Images/qr_icons/ic_delete.webp";

import { getMessage } from "CONFIG/i18n";
import { checkEmpty } from "UTILS/Utility";
import "./SettingsPage.less"

class EmailSettingsSection extends React.Component { 
    renderPreconfiguredEmailTableBody = () => {
      return (
        <tbody>
          {this.props.emailAddresses.map((email,index) =>              
            <tr className="cursorPointer" key={email.email + index} id={email.email + index}>
              <td className="emailRow col-4">
                {email.email}
              </td>
              <td className="emailRow col-1">
                <img
                  src={ic_delete}
                  className="cursorPointer px-2"
                  onClick={e => { this.props.handleDeleteEmailClick(index) }}
                />
              </td>
            </tr>
          )}
        </tbody>
      );
    };

    render() {
      return (
        <div className="section">
          <Row className="noMargin">
            <Col md={10}>
              {getMessage("ENTRY_EMAIL_ADDRESS")}
            </Col>
            <Col>
              <img
                style={{ transform: `rotate(${this.props.emailListRotation}deg)` }}
                className="dropDown cursorPointer floatRight"
                src={ic_arrow_down}
                onClick={() => this.props.handleEmailArrowClick()} />
            </Col> 
          </Row>
          <Collapse isOpen={this.props.isEmailListToggler}>
            <Card className="emailCard">
              <CardBody>
                <Row>
                  <Col xs={11} className="mainTitle px-2">
                    {getMessage("EMAIL_ADDRESS_LIST")}
                  </Col>
                  {!this.props.showAddEmailSection &&
                    <Col xs={1} className="justify-content-center">
                      <img src={ic_add}
                        className={"cursorPointer"}
                        onClick={() => { this.props.handleAddEmailIconClick() }}
                        data-toggle="tooltip"
                        data-placement="top"
                        title={getMessage("ADD_EMAIL_ADDRESS")} />
                    </Col>}
                </Row> 
                <Row className="emailCard">
                  <CardBody className="pt-0 pb-0">
                    <Row className="interCardContent">
                      <Col>
                        <Table bordered size="sm" className="storageTableWidth">
                          <thead>
                            <tr className="storageHead">
                              <th className="emailRow border-bottom rounded tableCol3">{getMessage("EMAIL")}</th>
                              <th className="emailRow border-bottom rounded tableCol1">{getMessage("ACTION")}</th>
                            </tr>
                          </thead>
                          {this.renderPreconfiguredEmailTableBody()}
                        </Table>
                      </Col>
                    </Row>
                  </CardBody>
                </Row>

                {this.props.showAddEmailSection &&
                   <Card>
                     <CardBody>
                       <Row>
                         <Col>
                           <Button close aria-label="Cancel" onClick={() => {this.props.onCancelEmailClick()}}>
                           </Button>
                         </Col>
                       </Row>
                       <Row className="noMargin mt-2">
                         <Col xs={3} className="pr-0"> {getMessage("EMAIL")}:
                         </Col>
                         <Col xs={9} className="pl-0">
                           <Input
                             type="email"
                             name="emailValue"
                             className="inputFormControl"
                             required
                             placeholder={getMessage("EMAIL_VALUE_PLACEHOLDER")}
                             onChange={this.props.handleEmailAddressInputChange}
                             value={this.props.emailValue}
                             maxLength={100}
                           />
                         </Col>
                       </Row>
                       {this.props.emailError !== "" ?
                         <Row>
                           <Col md={12} className="errors autoHeight">
                             {getMessage(this.props.emailError)}
                           </Col>
                         </Row>
                         : null
                       }
                       <Row className="interCardContent floatRight mx-2">
                         <Button
                           className={
                             (this.props.emailValue && !checkEmpty(this.props.emailValue.trim()) && this.props.showAddEmailSection)
                               ? "borderBtn cursorPointer bgwhite px-4 mx-1 mt-2"
                               : "borderBtn cursorPointer bgwhite px-4 mx-1 mt-2 isDisabled"
                           }
                           
                           onClick={this.props.handleAddEmailClick}
                         >
                           {getMessage("ADD")}
                         </Button>
                       </Row>
                     </CardBody>
                   </Card>}
              </CardBody>
            </Card>
              
          </Collapse>
        </div>
      )
    }
}
export default EmailSettingsSection;